import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
export default function TheWorldAwaits() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);
  return <section data-section-id="17420" id="from-vision-to-destination" className="relative h-screen w-full overflow-hidden flex items-center justify-center bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        {/*
         <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/luxury_yacht_sunset_poster.png" className="h-full w-full object-cover transition-opacity duration-1000">
          <source src="/videos/luxury_yacht_sunset.mp4" type="video/mp4" />
          {}
          <img src="https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/2.jpg" alt="AOTO Global Tourism Development" className="h-full w-full object-cover" />
         </video>
         */}
        {}
        <div className="absolute inset-0 bg-black/40 bg-gradient-to-t from-black/80 via-black/20 to-transparent !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/2.jpg)]" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="font-sans font-bold text-5xl md:text-7xl lg:text-[80px] text-foreground mb-6 leading-tight tracking-[-0.04em] drop-shadow-2xl"> Vision to
Destination</h1>
          
          <p className="font-sans text-sm md:text-lg leading-relaxed text-foreground/80 mb-10 max-w-3xl mx-auto drop-shadow-md">
            Integrated EPCO Excellence for World-Class Cultural Landscapes, Amusement Parks, and Luxury Resort Developments.
          </p>

          <div className="flex justify-center">
            <Button asChild size="lg" className="bg-transparent text-foreground border-2 border-foreground hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)] hover:border-[var(--primary)] text-lg px-10 py-7 h-auto rounded-none transition-all duration-500 shadow-lg hover:shadow-[0_0_30px_rgba(255,255,255,0.1)] hover:scale-105">
              <Link to="/ContactPage">
                Partner with AOTO
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 opacity-80">
        <span className="text-foreground/60 text-xs uppercase tracking-widest font-sans mb-2">
          Discover
        </span>
        <div className="h-16 w-[1px] bg-foreground/20 overflow-hidden relative">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-foreground animate-[drop_2s_infinite]" />
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes drop {
            0% { top: -50%; opacity: 0; }
            50% { opacity: 1; }
            100% { top: 100%; opacity: 0; }
          }
        `
    }} />
    </section>;
}